import { css } from 'linaria';

export const mediaCardContentStyle = css`
  && {
    display: flex;
    flex-direction: column;
    padding: 24px;

    @media (--to-desktop) {
      padding: 24px 16px;
    }
  }
`;

export const cardMediaStyle = css`
  height: 262px;

  @media (--only-desktop) {
    height: 200px;
  }

  @media (--to-desktop) {
    height: 156px;
  }
`;

export const cardTitleStyle = css`
  margin-bottom: 8px;
`;

export const cardDescriptionStyle = css`
  @media (--only-mobile) {
    && {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;
